import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/brand_health.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/competitive_benchmarking.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/digital_transformation.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/market_trend.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/process_improvment.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/product_development.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/security_threats.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/why_choose_us.png");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
